// Real client reviews. Each entry: { quote, name, company, town, rating (1-5) }.
// The reviews section renders only when this list is populated, and Review /
// aggregateRating structured data is published only for genuine client feedback.
export const REVIEWS = [];
